export default class PriceCalculator {

    height
    width
    unit

    constructor(mirrorSize) {
        this.height = mirrorSize.height || 0
        this.width = mirrorSize.width || 0
        this.unit = mirrorSize.unit || ''
    }

    static setMirrorSize(mirrorSize) {
        return new PriceCalculator(mirrorSize)
    }
    
    getPriceBySize(price, min_price, type) {

        if (!this.height || !this.width || !this.unit) {
            return min_price || 0;
        }
   
        switch (type) {
            case ('sqm'):
                return this.calculateSquareMeter(price, min_price)
            case ('linear'):
                return this.calculateLinearMeter(price, min_price)
            case ('flat'):
                return this.calculateFlat(price, min_price)
        }
        
        return 0;
    }

    calculateFlat(price, minimal = 0) {
        return Math.max(price, minimal);
    }

    calculateLinearMeter(price, minimal = 0) {
        return Math.max(this.getLinearArea() * price, minimal);
    }

    calculateSquareMeter(price, minimal = 0) {
        return Math.max(this.getSquareArea() * price, minimal);
    }

    convertToMeter(size, unit = false) {
        const divide = this.getSizeDivide(unit || this.unit)

        if (size <= 0 || divide <= 0) {
            return 0;
        }
        
        return (size / this.getSizeDivide(unit)) || 0;
    }

    getLinearArea() {
        return (2 * this.convertToMeter(this.height)) + (this.convertToMeter(2 * this.width))
    }

    getSizeDivide(sizeType = false) {
        let divide = 0;
        switch (sizeType || this.unit) {
            case 'mm':
                divide = 1000;
                break;
            case 'cm':
                divide = 100;
                break;
            case 'in':
                divide = 39.370079;
                break;
        }

        return divide;
    }

    getSquareArea() {
        return this.convertToMeter(this.height) * this.convertToMeter(this.width)
    }

    sizeType() {
        return this.sizeType;
    }

    static roundUp(number, decimals) {
        return Number((parseFloat(number)).toFixed(decimals || 4))
    }
}